import { CommonModalListItemStyle, CommonModalListWrapStyle } from '@styles/modal'
import styled from '@themes/theme'

export const SameMatchWrap = styled.div`
  ${CommonModalListWrapStyle};
  .same-match-list {
    ${CommonModalListItemStyle};
  }
`
